import { defineStore } from 'pinia';
import { UserState } from './types';

import { localStorage } from '@/utils/storage';
import { loginApi, logoutApi } from '@/api/auth';
import { LoginForm } from '@/api/auth/types';
import { Message } from '@arco-design/web-vue';
import { getUserBalance, loginWeb } from '@/api/user';
import { formatNumber } from '@/utils/common';

const useUserStore = defineStore('user', {
  state: (): UserState => ({
    userInfo: localStorage.get('userInfo') || {},
    promotionCode: localStorage.get('promotionCode') || '',
    isShowUnLoginModal: false,
    reply: localStorage.get('reply') || 0
  }),
  getters: {
    gettersReply: state => state.reply,
    gettersUserInfo: state => state.userInfo
  },
  actions: {
    async RESET_STATE() {
      this.$reset();
    },
    setReply(reply: number) {
      this.reply = reply;
      localStorage.set('reply', reply);
    },
    setPromotionCode(promotionCode: string) {
      this.promotionCode = promotionCode;
      localStorage.set('promotionCode', promotionCode);
    },
    async getUserBalance() {
      const res = await getUserBalance(this.userInfo.user.username);
      if (res.code == 200) {
        this.userInfo.user.balance = formatNumber(res.data.balance);
        localStorage.set('userInfo', this.userInfo);
      }
    },
    /**
     * 设置token
     */
    async setUserInfoByH5(token: string) {
      try {
        if (!token) {
          console.error('Token is required');
          return;
        }

        // 确保 userInfo 对象存在
        if (!this.userInfo) {
          this.userInfo = {};
        }

        // 确保 user 对象存在
        if (!this.userInfo.user) {
          this.userInfo.user = {};
        }

        // 设置 token
        this.userInfo.token = token;

        // 安全地存储到 localStorage
        try {
          localStorage.set('userInfo', this.userInfo);
        } catch (error) {
          console.error('Failed to save user info to localStorage:', error);
          // 如果存储失败，尝试使用备用存储方式
          try {
            sessionStorage.set('userInfo', this.userInfo);
          } catch (fallbackError) {
            console.error('Failed to save user info to sessionStorage:', fallbackError);
          }
        }
      } catch (error) {
        console.error('Error in setUserInfoByH5:', error);
        // 可以选择在这里添加错误恢复逻辑
      }
    },
    /**
     * 登录
     */
    login(data: LoginForm) {
      const { username, password } = data;
      return new Promise((resolve, reject) => {
        loginWeb({
          username: username.trim(),
          password: password
        })
          .then(response => {
            this.userInfo = response.data;
            this.userInfo.user = {
              ...response.data.user,
              balance: formatNumber(response.data.user.balance)
            };
            localStorage.set('userInfo', this.userInfo);
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    /**
     *  注销
     */
    logout() {
      // return new Promise((resolve, reject) => {
      //   logoutApi()
      //     .then(() => {
      localStorage.clear();
      window.location.href = '/';
      // this.RESET_STATE();
      //       resetRouter();
      //       resolve(null);
      //     })
      //     .catch(error => {
      //       reject(error);
      //     });
      // });
    },

    /**
     * 清除 Token
     */
    resetToken() {
      return new Promise(resolve => {
        localStorage.remove('userInfo');
        this.RESET_STATE();
        resolve(null);
      });
    },
    setIsShowUnLoginModal(isShowUnLoginModal: boolean) {
      this.isShowUnLoginModal = isShowUnLoginModal;
    }
  }
});

export default useUserStore;
